'use client';
import dynamic from 'next/dynamic';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import EcommerceServies from '@/components/technologies/ecommerce-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import ChooseeCommerce from '@/components/technologies/choose-ecommerce';
import TechnologyFaq from '@/components/technologies/technology-faq';
import ECommerceFAQ from '@/components/faqs/ecommerce-faq';
import Blog from '@/components/home/blog';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Empower your brand's digital presence with ROI-driven e-commerce development services. We help e-commerce business brands grow by optimizing their omnichannel presence using top e-commerce platforms, tools, and technologies."
                alt="eCommerce Development"
                title="eCommerce Development"
                width={1073}
                height={604}
                path={'ecommerce-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                E-commerce Development Company
            </TechHero>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="E-commerce Development" />

            <ChooseeCommerce title="Building E-commerce Websites, Stores and Apps that Brings Tangible Results"></ChooseeCommerce>
            <EcommerceServies />
            <HireProcess
                white={true}
                bg="bg-primary"
                pageTitle="Hire E-commerce Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using E-commerce,"
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For E-commerce  Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best E-commerce Developers"
                desc="Select from different engagement models to hire E-commerce Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On E-commerce Development Services" bg="bg-grey">
                <ECommerceFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
